import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Anchor, LogIn } from "lucide-react";
import { API } from "@/data";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("bm_token", data.token);
      navigate("/admin");
    } catch {
      setError("Identifiants invalides / Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-abyss flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <form onSubmit={submit} className="w-full max-w-md bg-surface border border-white/10 p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-9 h-9 bg-ember flex items-center justify-center rounded-sm"><Anchor size={18} /></span>
          <span className="font-display font-semibold tracking-wide text-lg uppercase">Sodimax Admin</span>
        </div>
        <label className="block text-[10px] uppercase tracking-widest text-steel-500 mb-2">Courriel</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-tactical mb-6" data-testid="admin-email-input" />
        <label className="block text-[10px] uppercase tracking-widest text-steel-500 mb-2">Mot de passe</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-tactical mb-6" data-testid="admin-password-input" />
        {error && <p className="text-ember text-sm mb-4" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full bg-ember hover:bg-emberdark disabled:opacity-50 text-white font-semibold px-8 py-3.5 rounded-sm transition-all duration-300 flex items-center justify-center gap-2">
          <LogIn size={16} /> {loading ? "…" : "Connexion"}
        </button>
      </form>
    </div>
  );
}
